import React from 'react';
import { Box, Text } from '@chakra-ui/react';

import colors from '../../../styles/theme/foundation/colors';

function RequirementBlock({ title, children }) {
  return (
    <Box
      backgroundColor="white"
      borderRadius="md"
      boxShadow="requirementBlock"
      flexBasis="100%"
      mb={4}
      py={6}
      textAlign="left"
    >
      <Box
        borderBottomColor={colors.greyScale['200']}
        borderBottomWidth="3px"
        pb={3}
        px={6}
        width="100%"
      >
        <Text textStyle="bodyXl500">{title}</Text>
      </Box>
      <Box pt={3} px={6} width="100%">
        {children}
      </Box>
    </Box>
  );
}

export default RequirementBlock;
